import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-action-buttons',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './action-buttons.component.html',
  styleUrl: './action-buttons.component.scss'
})
export class ActionButtonsComponent {
  @Output() readonly resetAll = new EventEmitter<void>();
  @Output() readonly saveToSpaces = new EventEmitter<void>();
}
